// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-generic-template-tsx": () => import("./../../../src/templates/Generic.template.tsx" /* webpackChunkName: "component---src-templates-generic-template-tsx" */)
}

